module.exports = __webpack_public_path__ + "static/media/jasparroos.e89aba69.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/letterfunnel/jasparroos.webp
// module id = 370
// module chunks = 0